import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { FaEdit, FaPlus } from "react-icons/fa";
import BranchTableModalContent from "../ModalContent/BranchTableModalContent";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { useGetBranchList } from "./hooks/useSettingsMasters";
import { useStateListData } from "../../Onboarding/hooks/useOnBoard";

const BranchDataColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Branch Name",
    selector: (row: { BranchName: string }) => row?.BranchName || "-",
    sortable: true,
    width: "210px",
  },
  {
    name: "State",
    selector: (row: { StateName: string }) => row?.StateName || "-",
    sortable: true,
    width: "210px",
  },
  {
    name: "Action",
    width: "100px",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

interface formDataInteface {
  Name_HQ: string | number;
  Branch_Code: string | number;
  State: string | number;
}

const BranchTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalStatus, setModalStatus] = useState<string>("");
  const [branchId, setBranchId] = useState<string | number>("");
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });
  const [formData, setformData] = useState<formDataInteface>({
    Name_HQ: "",
    Branch_Code: "",
    State: "",
  });

  const { data: branchListData } = useGetBranchList({
    enable: true,
    params: {
      page: filtersState?.page,
      limit: filtersState?.limit,
      search: filtersState?.search,
      fetch: null,
    },
  });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setformData({
      Name_HQ: "",
      Branch_Code: "",
      State: "",
    });
    setModalStatus("");
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setformData({
      Name_HQ: "",
      Branch_Code: "",
      State: "",
    });
    setModalStatus("");
  };

  const handleEdit = (row: any) => {
    setSelectedRow(row);
    setIsModalOpen(!isModalOpen);
    setModalStatus("Edit");
    setBranchId(row?.BranchId);
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };
  return (
    <div className="container mt-3">
      <BasicDataTable
        Title="Branch/HQ"
        data={branchListData?.data?.BranchData || []}
        columns={BranchDataColumns(handleEdit)}
        search={false}
        headerContent={
          <button
            onClick={() => toggleModal()}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaPlus /> <span>Add Branch / HQ</span>
          </button>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={branchListData?.data?.Pagination?.TotalCount || 0}
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title="Add Branch/HQ"
        size="md"
        content={
          <BranchTableModalContent
            handleClose={handleClose}
            setIsModalOpen={setIsModalOpen}
            selectedRow={selectedRow}
            modalStatus={modalStatus}
            branchId={branchId}
            setformData={setformData}
            formData={formData}
          />
        }
      />
    </div>
  );
};

export default BranchTable;
